<script setup lang="ts">
import Icon from '../../components/icon/Icon.vue';
import type { AppShellSidebarNavTarget, SidebarItem } from '../../components/Sidebar/Sidebar.vue';
import type { AppShellSidebarVariant } from './AppShellSidebarFooter.vue';

export interface AppShellSidebarNavProps {
	items: SidebarItem[];
	activeRoute?: string;
	variant?: AppShellSidebarVariant;
}

withDefaults(defineProps<AppShellSidebarNavProps>(), {
	variant: 'desktop',
});

defineEmits<{
	navigate: [to: AppShellSidebarNavTarget];
}>();
</script>

<template>
	<nav
		:class="[
			'flex-1 overflow-y-auto px-5',
			variant === 'desktop' ? 'py-10' : 'pb-4',
		]"
	>
		<button
			v-for="item in items"
			:key="item.to"
			type="button"
			:class="[
				'mb-sm flex w-full items-center gap-3 rounded-md px-3 py-3 transition-colors duration-normal',
				variant === 'desktop'
					? activeRoute === item.to
						? 'bg-primary text-white'
						: 'text-white hover:text-gray-300'
					: activeRoute === item.to
						? 'bg-primary/10 text-primary'
						: 'text-on-surface-variant hover:bg-surface-elevated hover:text-on-surface',
			]"
			@click="$emit('navigate', item.to)"
		>
			<span
				:class="[
					'flex-1 text-left text-sm',
					variant === 'mobile' ? 'font-semibold' : '',
				]"
			>
				{{ item.label }}
			</span>
			<span
				v-if="item.badge"
				class="rounded-full bg-primary/20 px-sm py-xs text-label font-bold text-primary"
			>
				{{ item.badge }}
			</span>
			<Icon
				name="chevronRight"
				size="sm"
				:class="
					variant === 'desktop' && activeRoute === item.to
						? 'text-white'
						: 'text-gray-400'
				"
			/>
		</button>
	</nav>
</template>
